import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useTeacherSubjectGet = (teacherId) => {
  const requestUrl = `${API_BASE_URL}/api/v2/teacher-subjects/${teacherId}/`;
  return useRestQuery(requestUrl, { skip: !teacherId });
};

export default useTeacherSubjectGet;
